// ScriptCraft AI MVP
// Goal: Generate short-form video scripts (Instagram Reels, YouTube Shorts)

import React, { useState, useEffect } from 'react';
import { Input } from '../../components/ui/input';
import { Textarea } from '../../components/ui/textarea';
import { Button } from '../../components/ui/button';
import { Loader2 } from 'lucide-react';
import AppShell from '../../components/AppShell';
import { useTranslation } from 'react-i18next';

const API = process.env.REACT_APP_API_BASE;



export default function ScriptCraftAI() {
  const { t } = useTranslation();
  const [topic, setTopic] = useState('');
  const [tone, setTone] = useState('Friendly');
  const [length, setLength] = useState('Short');
  const [loading, setLoading] = useState(false);
  const [output, setOutput] = useState('');
  const [language, setLanguage] = useState('English');

  useEffect(() => {
    document.title = t('scriptcraft');
  }, []);

  const handleGenerate = async () => {
    setLoading(true);
    setOutput('');

    try {
      const response = await fetch(`${API}/api/script-craft/generate`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ topic, tone, length, language })
      });

      const data = await response.json();
      setOutput(data.script);
    } catch (error) {
      setOutput(t('error_script'));
    }

    setLoading(false);
  };

  return (
    <AppShell>
      <div className="col-span-12 text-center space-y-1">
    <div className="max-w-3xl mx-auto p-6">
      <h1 className="text-2xl font-bold mb-4">🎬 {t('Script Craft')}</h1>
      <p className="text-muted-foreground mb-6">{t('scriptcraftsubtitle')}</p>

      <div className="space-y-4">
        <Input
          placeholder={t('placeholder_topic')}
          value={topic}
          onChange={(e) => setTopic(e.target.value)}
        />

        <div className="flex gap-4">
          <select
            className="w-full border rounded p-2"
            value={tone}
            onChange={(e) => setTone(e.target.value)}
          >
            <option value="Friendly">{t('friendly')}</option>
            <option value="Professional">{t('professional')}</option>
            <option value="Witty">{t('witty')}</option>
            <option value="Luxury">{t('luxury')}</option>
          </select>

          <select
            className="w-full border rounded p-2"
            value={length}
            onChange={(e) => setLength(e.target.value)}
          >
            <option value="Short">{t('short')}</option>
            <option value="Medium">{t('medium')}</option>
            <option value="Long">{t('long')}</option>
          </select>
        </div>
        <select
  className="w-full border rounded p-2"
  value={language}
  onChange={(e) => setLanguage(e.target.value)}
>
  <option value="English">English</option>
  <option value="Hindi">हिन्दी</option>
  <option value="Arabic">العربية</option>
</select>
        <Button onClick={handleGenerate} disabled={loading || !topic}>
          {loading ? <Loader2 className="animate-spin w-4 h-4 mr-2" /> : t('generate_script')}
        </Button>

        {output && (
          <Textarea
            className="mt-4"
            rows={10}
            value={output}
            readOnly
          />
        )}
      </div>
    </div>
    </div>
    </AppShell>
  );
}
